module.exports={author:"Mónica de la Torre",date:"06/21/2021",publishDate:"06/21/2021",highlighted:!1,tags:"",title:"December"};